import { combineReducers } from "redux";
import {
  BOARDFAILURE,
  BOARDSUCCESS,
  GET_PAPER_ID,
  GET_USER_FAILED,
  GET_USER_SUCCESS,
  HEADERPATH,
  LOADING_START,
  LOADING_STOP,
  LOGINFAILURE,
  LOGINSUCCESS,
  MEDIUMFAILURE,
  MEDIUMSUCCESS,
  NOTICEFAILURE,
  NOTICESUCCESS,
  RANDOMDATA,
  SELECTEDDATA,
  SEMESTERAUTOFAILURE,
  SEMESTERAUTOSUCCESS,
  SEMESTERFAILURE,
  SEMESTERSUCCESS,
  STANDARDAUTOFAILURE,
  STANDARDAUTOSUCCESS,
  STANDARDFAILURE,
  STANDARDSUCCESS,
  SUBJECTAUTOFAILURE,
  SUBJECTAUTOSUCCESS,
  SUBJECTFAILURE,
  SUBJECTSUCCESS,
} from "./actionTypes";
import { PaperData } from "../helper/PaperData";

const INITIAL_STATE = {
  Loader: false,
  Data: PaperData,
  LoginData: {},
  BoardData: {},
  MediumData: {},
  StandardData: {},
  StandardAutoData: {},
  SemesterAutoData: {},
  SubjectAutoData: {},
  SubjectData: {},
  NoticeData: {},
  SemesterData: {},
  SelectedData: {},
  HeaderPath: "",
  RandomData: {},
  paperId: "",
};

// const ClearLoginReducer = (state = INITIAL_STATE, action) => {
//   switch (action.type) {
//     case LOGOUT:
//       return {
//         ...state,
//         LoginData: {},
//       };
//     default:
//       return state;
//   }
// };

const LoaderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING_START:
      return { ...state, Loader: true };
    case LOADING_STOP:
      return { ...state, Loader: false };
    default:
      return state;
  }
};

const LoginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGINSUCCESS:
      return {
        ...state,
        LoginData: action.payload,
      };
    case LOGINFAILURE:
      return {
        ...state,
        LoginData: action.payload,
      };
    default:
      return state;
  }
}

const BoardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BOARDSUCCESS:
      return {
        ...state,
        BoardData: action.payload,
      };
    case BOARDFAILURE:
      return {
        ...state,
        BoardData: action.payload,
      };
    default:
      return state;
  }
}

const MediumReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MEDIUMSUCCESS:
      return {
        ...state,
        MediumData: action.payload,
      };
    case MEDIUMFAILURE:
      return {
        ...state,
        MediumData: action.payload,
      };
    default:
      return state;
  }
}

const StandardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STANDARDSUCCESS:
      return {
        ...state,
        StandardData: action.payload,
      };
    case STANDARDFAILURE:
      return {
        ...state,
        StandardData: action.payload,
      };
    default:
      return state;
  }
}

const StandardAutoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STANDARDAUTOSUCCESS:
      return {
        ...state,
        StandardAutoData: action.payload,
      };
    case STANDARDAUTOFAILURE:
      return {
        ...state,
        StandardAutoData: action.payload,
      };
    default:
      return state;
  }
}

const SemesterReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SEMESTERSUCCESS:
      return {
        ...state,
        SemesterData: action.payload,
      };
    case SEMESTERFAILURE:
      return {
        ...state,
        SemesterData: action.payload,
      };
    default:
      return state;
  }
}

const SemesterAutoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SEMESTERAUTOSUCCESS:
      return {
        ...state,
        SemesterAutoData: action.payload,
      };
    case SEMESTERAUTOFAILURE:
      return {
        ...state,
        SemesterAutoData: action.payload,
      };
    default:
      return state;
  }
}

const SubjectReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SUBJECTSUCCESS:
      return {
        ...state,
        SubjectData: action.payload,
      };
    case SUBJECTFAILURE:
      return {
        ...state,
        SubjectData: action.payload,
      };
    default:
      return state;
  }
}

const SubjectAutoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SUBJECTAUTOSUCCESS:
      return {
        ...state,
        SubjectAutoData: action.payload,
      };
    case SUBJECTAUTOFAILURE:
      return {
        ...state,
        SubjectAutoData: action.payload,
      };
    default:
      return state;
  }
}

const NoticeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NOTICESUCCESS:
      return {
        ...state,
        NoticeData: action.payload,
      };
    case NOTICEFAILURE:
      return {
        ...state,
        NoticeData: action.payload,
      };
    default:
      return state;
  }
}

const SelectedDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECTEDDATA:
      return {
        ...state,
        Data: action.payload,
      };
    default:
      return state;
  }
}

const HeaderPathReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HEADERPATH:
      return {
        ...state,
        HeaderPath: action.params,
      };
    default:
      return state;
  }
}

const RandomPathReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RANDOMDATA:
      return {
        ...state,
        RandomData: action.params,
      };
    default:
      return state;
  }
}

const GetUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_USER_SUCCESS:
      return {
        ...state,
        GetUserData: action.params,
      };
    case GET_USER_FAILED:
      return {
        ...state,
        GetUserData: action.params,
      };
    default:
      return state;
  }
}

const GetPaperIdReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PAPER_ID:
      return {
        ...state,
        paperId: action.params,
      };
    default:
      return state;
  }
}

export default combineReducers({
  // ClearLogin: ClearLoginReducer,
  Loader: LoaderReducer,
  Login: LoginReducer,
  Board: BoardReducer,
  Medium: MediumReducer,
  Standard: StandardReducer,
  Semester: SemesterReducer,
  Subject: SubjectReducer,

  StandardAuto: StandardAutoReducer,
  SemesterAuto: SemesterAutoReducer,
  SubjectAuto: SubjectAutoReducer,

  SelectedDetail: SelectedDataReducer,
  Notice: NoticeReducer,
  HeaderPath: HeaderPathReducer,
  RandomData: RandomPathReducer,
  GetUser: GetUserReducer,
  PaperId: GetPaperIdReducer,
});
